import React from 'react';
import { motion } from 'framer-motion';
import { PhoneRingIcon } from './PlumbingIcons';
export function FinalCTA() {
  const scrollToContact = () => {
    document.getElementById('contacto')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-32 px-4 relative z-10 bg-dark overflow-hidden border-t border-dark-card" data-id="element-138">
      {/* Background Elements */}
      <div className="absolute inset-0 z-0 pointer-events-none" data-id="element-139">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[40rem] h-[40rem] bg-emerald/5 rounded-full blur-[120px]" data-id="element-140" />
      </div>

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-141">
        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="flex justify-center mb-8" data-id="element-142">
          <div className="w-20 h-20 rounded-full bg-emerald/10 flex items-center justify-center border border-emerald/30 shadow-neon-green" data-id="element-143">
            <PhoneRingIcon size={40} className="text-emerald animate-pulse-glow" data-id="element-144" />
          </div>
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2,
        ease: 'easeOut'
      }} className="text-4xl md:text-6xl font-black text-white tracking-tight mb-10 leading-tight" data-id="element-145">
          Deja de perder dinero por fugas en tu marketing.{' '}
          <br className="hidden md:block" data-id="element-146" />
          <span className="text-gold" data-id="element-147">
            Es hora de inyectar llamadas de emergencia.
          </span>
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4,
        ease: 'easeOut'
      }} className="flex flex-col items-center" data-id="element-148">
          <button onClick={scrollToContact} className="group relative inline-flex items-center justify-center px-8 py-6 text-lg md:text-2xl font-black text-dark bg-gold rounded-full overflow-hidden transition-all hover:scale-105 shadow-neon-green-lg hover:shadow-[0_0_50px_rgba(80,200,120,0.8)] w-full md:w-auto" data-id="element-149">
            <span className="relative z-10 flex items-center gap-3" data-id="element-150">
              AGENDAR DIAGNÓSTICO DE PLOMERÍA GRATIS
            </span>
            <div className="absolute inset-0 h-full w-full bg-white/20 scale-x-0 group-hover:scale-x-100 origin-left transition-transform duration-300 ease-out" data-id="element-151" />
          </button>

          <a href="https://calendar.app.google/gDsqAVqmwUYm" target="_blank" rel="noopener noreferrer" className="mt-6 text-emerald hover:text-gold transition-colors font-semibold underline underline-offset-4 text-lg" data-id="element-152">
            O agenda tu cita directamente en nuestro calendario
          </a>

          <p className="mt-8 text-gray-400 font-medium flex items-center gap-2" data-id="element-153">
            <span className="w-2 h-2 rounded-full bg-emerald animate-pulse" data-id="element-154" />
            Solo aceptamos un plomero por zona. Verifica disponibilidad.
          </p>
        </motion.div>
      </div>
    </section>;
}